import React, { useEffect, useRef } from 'react';
import { useBOMStore } from 'src/hooks/bom';
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import useReduxState from "../../../../hooks/useReduxState";
import { useSelector } from "react-redux";
import $ from "jquery";
import "floating-scroll";
import stickyTableCommon from 'src/helper/stickyTableCommon';
import BOMRepository from 'src/repository/BOMRepository';
import System from 'src/helper/system';
import BomRemovePart from './BomRemovePart';

const BomNoMatchTable = (props) => {
    const [{ bom_detail_NoMatch_list }] = useBOMStore();
    const noMatchListRecord = bom_detail_NoMatch_list?.records;
    const displayStatus = noMatchListRecord && Object.keys(noMatchListRecord).length > 0;
    const [top, SetTop] = useReduxState({}, 'BOM_DETAIL_TOP_PARAM_FOP_LIMIT', true);
    const refLoadMore = useRef(null);
    const axios_indicator = useSelector((state) => state.entities.system.axios_indicator);

    useEffect(() => {
        setTimeout(() => {
            $(".floating-table").floatingScroll("init");
        }, 2000)
    }, [axios_indicator]);

    const [__check] = useAxiosIndicatorCheck();

    useEffect(() => {
        if (noMatchListRecord?.length > 0) {
            stickyTableCommon('bomnomatch-table', null);
        }
    }, [bom_detail_NoMatch_list, __check(['BOM_TAB_API_CALL', 'BOM_API_CALL']).status]);

    return (
        <>
            <div className="tab-content p-0">
                <div id='sticky-table-wrapper'
                    className={__check(['BOM_TAB_API_CALL', 'BOM_API_CALL']).status ?
                        "floating-table table-responsive loader-wrapper-outer minh350 mb-0" :
                        "floating-table table-responsive mb-0 sticky-table-wrapper"}>
                    {__check(['BOM_TAB_API_CALL', 'BOM_API_CALL'], { overlay: true }).render}
                    <table id='bomnomatch-table' className="bs5 table table-bordered">
                        <thead style={{ display: displayStatus ? '' : 'none' }}>
                            <tr>
                                <th className="w-85"></th>
                                <th className="text-nowrap w200">Part Number</th>
                                <th className="text-nowrap w220">Manufacturer Part Number</th>
                                <th className="text-nowrap w150">Quantity</th>
                                <th className="text-nowrap minw220">Price</th>
                                <th className="text-nowrap w200">Availability</th>
                                <th className="text-nowrap">Manufacturer</th>
                                <th className="text-nowrap">Information</th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayStatus && Object.entries(noMatchListRecord).map(([key, record]) => (
                                <tr className="align-top" key={key}>
                                    <td>
                                        <span className="index-count">{record.sequenceNumber}</span>
                                    </td>
                                    {!record.isDeleted ? (
                                        <>
                                            <td>
                                                <div className="d-flex w-100 justify-content-between align-items-center">
                                                    <div className="form-control form-control-sm"><span className='mt-1 d-block text-nowrap'>{record.partNumber}
                                                    </span></div>
                                                    <BomRemovePart bomId={record.bomId} bomDetailId={record.bomDetailId} removeType={"noMatches"}  removePartNumber={record.partNumber}/>
                                                </div>
                                            </td>
                                            <td>
                                                <p className='mb-0'>No match found</p>
                                                <a href={void (0)} className="d-block text-blue2"
                                                    onClick={() => {
                                                        System.popup('FindPartPopup', { bomDetailId: record.bomDetailId, no_match: true, manufacturerPartNumber: record.manufacturerPartNumber, search_param: record.partNumber, addFrom: "FindPart" });
                                                    }}>Find part</a>
                                            </td>
                                            <td>
                                                <div className="form-control form-control-sm"><span className='mt-1 d-block text-nowrap'>{record.quantity}
                                                </span></div>
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </>
                                    ) : (
                                        <>
                                            <td>Deleted: {record.manufacturerPartNumber}</td>
                                            <td ></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {displayStatus && Object.entries(noMatchListRecord).length < (bom_detail_NoMatch_list?.count + bom_detail_NoMatch_list?.deleted) && (
                <div className="pagination-row text-center"
                    style={__check(['BOM_TAB_API_CALL', 'BOM_API_CALL', 'CART_API_CALL']).status ? { display: 'none' } : {}}>
                    <button ref={refLoadMore} onClick={() => SetTop(BOMRepository.loadMore(top, props))}
                        className="bs5 m-t-30 m-b-30 btn btn-secondary w155">Load More
                    </button>
                </div>
            )}
            {!displayStatus || Object.entries(noMatchListRecord).length >= bom_detail_NoMatch_list?.count && (
                <div className="pagination-row text-center"></div>
            )}
        </>
    );
};

export default BomNoMatchTable;
